import { IMedia } from "./media"
import { IProperties, Status } from "./property"

export interface IInvestment{
    _id:string,
    property:string|IProperties,
    documents:string[]|Partial<IMedia>[],
    floorplan:Partial<IMedia>|string,
    heroText:string,
    heroImage:Partial<IMedia>|string,
    investmentDocument?:Partial<IMedia>|string,
    plans:option[],
    createdBy:string,
    status:Status,
    investmentStatus:InvestmentStatus,
    createdAt:Date,
    views:number
}

export enum InvestmentStatus{
  COMPLETED="COMPLETED",
  ONGOING="ONGOING"
}


export type option={
    isActive:boolean,
    name:string,
    heading:string,
    subHeading:string,
    benefits1:string,
    benefits2:string,
    benefits3:string,
    investorType:string
}
export enum InvestmentTypes{
    OUTRIGHT="Outright Payment",
    MORTGAGE="Mortgage Plan",
    ALTERNATE="Alternate Asset Financing"
}

export const PriceRange:{label:string,value:string}[]=[
    {label:"₦50M-₦100M",  value:"₦50M-₦100M"},
    {label:"₦100M-₦250M", value:"₦100M-₦250M"},
    {label:"₦250M-₦500M", value:"₦250M-₦500M"},
    {label:"₦500M-Above", value:"₦500M-Above"},
]